import {RouteObject} from 'react-router-dom';

export const AppAdminRoutes: RouteObject[] = [];
